<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item label="分组">
                <el-select v-model="formInline.typeId" filterable>
                    <el-option
                            v-for="item in getImageTypeList"
                            :key="item.typeId"
                            :label="item.typeName"
                            :value="item.typeId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleAddType">新增类型</el-button>
            </el-form-item>
            <el-form-item>
                <uploadComponents :isSelect="false" :groupId="formInline.typeId"></uploadComponents>
            </el-form-item>
        </el-form>
        <el-table :data="getImageList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column type="expand" label="展开看详情"  width="100">
                <template slot-scope="scope">
                    <el-form label-position="left"  class="demo-table-expand">
                        <el-form-item label="图片路径">
                            <span>{{ scope.row.allImagePath }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column prop="imageName" label="图片描述" sortable></el-table-column>
            <el-table-column prop="imagePath" label="图片路径" sortable></el-table-column>
            <el-table-column label="图片路径" >
                <template  slot-scope="scope">
                    <img :src="scope.row.allImagePath" width="120" height="80" class="head_pic"/>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="80">
                <template slot-scope="scope">
                      <el-button type="warning " size="mini" @click="deleteImage(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="新增分组" :visible.sync="dialogFormVisibleType" center>
            <el-form :model="formType" label-width="120px">
                <el-form-item label="分类名称" >
                    <el-input v-model="formType.typeName" placeholder="分类名称"></el-input>
                </el-form-item>
                <el-form-item label="分类路径">
                    <el-input v-model="formType.typePath" placeholder="只能输入字母，建议分类名称全拼"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleType = false">取 消</el-button>
                <el-button type="primary" @click="saveImageType(formType)">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getImageTypeList,saveImageType,getImageList,deleteImage} from '../../api/api';
    import uploadComponents from '@/components/upload';

    //定义组件
    export default{
        data(){
            return {
                getImageList:[],
                getImageTypeList: [],
                loading:true,
                dialogFormVisibleType:false,
                formType:{
                    "typeName":"",
                    "typePath":"",
                },
                formInline:{
                    "typeId":"",
                    currentPage:1,
                    pageSize:10,
                    recordsTotal:0,
                }
            }
        },
        //挂载时候执行
        mounted(){
            //获取查询条件下拉列表
            getImageTypeList({}).then((res) => {
                this.getImageTypeList = res.data;
                this.formInline.typeId=this.getImageTypeList[0].typeId;
                this.getList();
            })
        },
        components:{
            uploadComponents
        },
        methods:{
            //定义查询方法
            getList(){
                this.loading = true;
                getImageList(this.formInline).then((res) => {
                    this.loading = false;
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline.recordsTotal = res.data.value.total;
                        this.getImageList = res.data.value.list;
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAddType(){
                this.dialogFormVisibleType = true;
            },
            saveImageType(formType){
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveImageType(formType).then((res) => {
                    loading.close();
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.dialogFormVisibleType = false;
                        getImageTypeList({}).then((res) => {
                            this.getImageTypeList = res.data;
                        })
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            deleteImage(row){
                this.$confirm('删除图片, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteImage({imageId:row.imageId}).then((res) => {
                        loading.close();
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/image/imageList.vue